module.exports = __webpack_public_path__ + "05_veryshort_gold.686b7935.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/05_veryshort_gold.png
// module id = 7U0U
// module chunks = 0